<template>
    <div class="p-4">

        <div v-if="issues.length == 0">
            <p class="text-center mb-0">{{ $t('issues.no-issue') }}</p>
        </div>
        
        <div v-else class="timeline timeline-one-side" data-timeline-content="axis" data-timeline-axis-style="dashed">
            <div v-for="(issue, index) in issues" :key="index" class="timeline-block">

                <span class="timeline-step badge-default">
                    <i class="fas fa-thumbtack"></i>
                </span>
                
                <div class="timeline-content">
                    <issue
                        :issue="issue"
                        :edit="true"
                        @update="update"
                        @remove="remove"
                    >
                    </issue>
                </div>
                
            </div>
        </div>

    </div>
</template>

<script>
    import CrudClient from '@trax/classes/CrudClient'
    import Issue from './Issue'
    import moment from 'moment'

    export default {

        components: {
            Issue,
        },

        props: {

            modal: {
                type: Object,
                required: true
            },

            registration: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },

            session: {
                type: Object,
                default: null
            },

            timeslot: {
                type: Object,
                default: null
            },
        },

        data() {
            const context = this.session ? 'session' : 'log'
            let endpoint = '/socrates/api/front/dashboard/data/context/' + context + '/issues'

            let client = new CrudClient(endpoint, {
                timeslot_id: this.timeslot ? this.timeslot.id : null,
                registration_id: this.registration.id,
                simulation_id: this.simulation.id,
                session_id: this.session ? this.session.id : null,
            })
            return {
                endpoint,
                client,
                issues: [],
                loaded: false,
                moment: moment,
            }
        },

        watch: {

            modal(val) {
                if (val.show) {
    
                    // Update the query now because timeslot may have changed.
                    this.client.query = {
                        timeslot_id: this.timeslot ? this.timeslot.id : null,
                        registration_id: this.registration.id,
                        simulation_id: this.simulation.id,
                        session_id: this.session ? this.session.id : null,
                    }

                    // The modal has just been opened. Update the list.
                    this.list()
                }
            },
        },

        methods: {

            list() {
                this.loaded = false
                this.client.list().then(resp => {          
                    this.issues = resp.data.data
                    this.loaded = true
                })
            },

            update(issue) {
                this.$emit('update', issue)
            },

            remove(issue) {
                this.$emit('remove', issue)
            },

            enteredAt(issue) {
                return this.moment(issue.entered_at).format('YYYY/MM/DD') + ' at ' + this.moment(issue.entered_at).format('HH:mm')
            }
        }
    }
</script>

<style scoped>

    .description {
        white-space: pre-wrap;
    }
    @media (min-width: 992px) {
        .timeline-one-side .timeline-content {
            max-width: none;
        }
    }

</style>
